/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import {
  DeploymentSourceDeployment,
  DeploymentSourceDeployment$Outbound,
  DeploymentSourceDeployment$outboundSchema,
} from "./deploymentsourcedeployment.js";
import {
  DeploymentSourceGit,
  DeploymentSourceGit$Outbound,
  DeploymentSourceGit$outboundSchema,
} from "./deploymentsourcegit.js";
import {
  DeploymentSourceImage,
  DeploymentSourceImage$Outbound,
  DeploymentSourceImage$outboundSchema,
} from "./deploymentsourceimage.js";

export type V1DeploymentsCreateDeploymentRequestBody3 = {
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  project: string;
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  app: string;
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  environment: string;
  /**
   * Build from the app's connected GitHub repository.
   */
  git?: DeploymentSourceGit | undefined;
  /**
   * Deploy a prebuilt Docker image as-is.
   */
  image?: DeploymentSourceImage | undefined;
  /**
   * Re-run an existing deployment.
   */
  deployment: DeploymentSourceDeployment;
};

export type V1DeploymentsCreateDeploymentRequestBody2 = {
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  project: string;
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  app: string;
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  environment: string;
  /**
   * Build from the app's connected GitHub repository.
   */
  git: DeploymentSourceGit;
  /**
   * Deploy a prebuilt Docker image as-is.
   */
  image?: DeploymentSourceImage | undefined;
  /**
   * Re-run an existing deployment.
   */
  deployment?: DeploymentSourceDeployment | undefined;
};

export type V1DeploymentsCreateDeploymentRequestBody1 = {
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  project: string;
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  app: string;
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  environment: string;
  /**
   * Build from the app's connected GitHub repository.
   */
  git?: DeploymentSourceGit | undefined;
  /**
   * Deploy a prebuilt Docker image as-is.
   */
  image: DeploymentSourceImage;
  /**
   * Re-run an existing deployment.
   */
  deployment?: DeploymentSourceDeployment | undefined;
};

/**
 * Create a deployment. Provide exactly one of git, image, or deployment.
 */
export type V1DeploymentsCreateDeploymentRequestBodyUnion =
  | V1DeploymentsCreateDeploymentRequestBody1
  | V1DeploymentsCreateDeploymentRequestBody2
  | V1DeploymentsCreateDeploymentRequestBody3;

/** @internal */
export type V1DeploymentsCreateDeploymentRequestBody3$Outbound = {
  project: string;
  app: string;
  environment: string;
  git?: DeploymentSourceGit$Outbound | undefined;
  image?: DeploymentSourceImage$Outbound | undefined;
  deployment: DeploymentSourceDeployment$Outbound;
};

/** @internal */
export const V1DeploymentsCreateDeploymentRequestBody3$outboundSchema:
  z.ZodType<
    V1DeploymentsCreateDeploymentRequestBody3$Outbound,
    z.ZodTypeDef,
    V1DeploymentsCreateDeploymentRequestBody3
  > = z.object({
    project: z.string(),
    app: z.string(),
    environment: z.string(),
    git: DeploymentSourceGit$outboundSchema.optional(),
    image: DeploymentSourceImage$outboundSchema.optional(),
    deployment: DeploymentSourceDeployment$outboundSchema,
  });

export function v1DeploymentsCreateDeploymentRequestBody3ToJSON(
  v1DeploymentsCreateDeploymentRequestBody3:
    V1DeploymentsCreateDeploymentRequestBody3,
): string {
  return JSON.stringify(
    V1DeploymentsCreateDeploymentRequestBody3$outboundSchema.parse(
      v1DeploymentsCreateDeploymentRequestBody3,
    ),
  );
}

/** @internal */
export type V1DeploymentsCreateDeploymentRequestBody2$Outbound = {
  project: string;
  app: string;
  environment: string;
  git: DeploymentSourceGit$Outbound;
  image?: DeploymentSourceImage$Outbound | undefined;
  deployment?: DeploymentSourceDeployment$Outbound | undefined;
};

/** @internal */
export const V1DeploymentsCreateDeploymentRequestBody2$outboundSchema:
  z.ZodType<
    V1DeploymentsCreateDeploymentRequestBody2$Outbound,
    z.ZodTypeDef,
    V1DeploymentsCreateDeploymentRequestBody2
  > = z.object({
    project: z.string(),
    app: z.string(),
    environment: z.string(),
    git: DeploymentSourceGit$outboundSchema,
    image: DeploymentSourceImage$outboundSchema.optional(),
    deployment: DeploymentSourceDeployment$outboundSchema.optional(),
  });

export function v1DeploymentsCreateDeploymentRequestBody2ToJSON(
  v1DeploymentsCreateDeploymentRequestBody2:
    V1DeploymentsCreateDeploymentRequestBody2,
): string {
  return JSON.stringify(
    V1DeploymentsCreateDeploymentRequestBody2$outboundSchema.parse(
      v1DeploymentsCreateDeploymentRequestBody2,
    ),
  );
}

/** @internal */
export type V1DeploymentsCreateDeploymentRequestBody1$Outbound = {
  project: string;
  app: string;
  environment: string;
  git?: DeploymentSourceGit$Outbound | undefined;
  image: DeploymentSourceImage$Outbound;
  deployment?: DeploymentSourceDeployment$Outbound | undefined;
};

/** @internal */
export const V1DeploymentsCreateDeploymentRequestBody1$outboundSchema:
  z.ZodType<
    V1DeploymentsCreateDeploymentRequestBody1$Outbound,
    z.ZodTypeDef,
    V1DeploymentsCreateDeploymentRequestBody1
  > = z.object({
    project: z.string(),
    app: z.string(),
    environment: z.string(),
    git: DeploymentSourceGit$outboundSchema.optional(),
    image: DeploymentSourceImage$outboundSchema,
    deployment: DeploymentSourceDeployment$outboundSchema.optional(),
  });

export function v1DeploymentsCreateDeploymentRequestBody1ToJSON(
  v1DeploymentsCreateDeploymentRequestBody1:
    V1DeploymentsCreateDeploymentRequestBody1,
): string {
  return JSON.stringify(
    V1DeploymentsCreateDeploymentRequestBody1$outboundSchema.parse(
      v1DeploymentsCreateDeploymentRequestBody1,
    ),
  );
}

/** @internal */
export type V1DeploymentsCreateDeploymentRequestBodyUnion$Outbound =
  | V1DeploymentsCreateDeploymentRequestBody1$Outbound
  | V1DeploymentsCreateDeploymentRequestBody2$Outbound
  | V1DeploymentsCreateDeploymentRequestBody3$Outbound;

/** @internal */
export const V1DeploymentsCreateDeploymentRequestBodyUnion$outboundSchema:
  z.ZodType<
    V1DeploymentsCreateDeploymentRequestBodyUnion$Outbound,
    z.ZodTypeDef,
    V1DeploymentsCreateDeploymentRequestBodyUnion
  > = z.union([
    z.lazy(() => V1DeploymentsCreateDeploymentRequestBody1$outboundSchema),
    z.lazy(() => V1DeploymentsCreateDeploymentRequestBody2$outboundSchema),
    z.lazy(() => V1DeploymentsCreateDeploymentRequestBody3$outboundSchema),
  ]);

export function v1DeploymentsCreateDeploymentRequestBodyUnionToJSON(
  v1DeploymentsCreateDeploymentRequestBodyUnion:
    V1DeploymentsCreateDeploymentRequestBodyUnion,
): string {
  return JSON.stringify(
    V1DeploymentsCreateDeploymentRequestBodyUnion$outboundSchema.parse(
      v1DeploymentsCreateDeploymentRequestBodyUnion,
    ),
  );
}
